import React, {useState, createContext} from 'react';
import './index.css';
import Home from './Components/Home';
import Login from './Components/login';
import RegistFond from './Components/register-fond';
import RegistDepense from './Components/register-depense';
import Cloture from './Components/cloture';
import Rapport from './Components/rapport';
import GrandLivre from './Components/grand-livre';
import JrnDon from './Components/jrn-don';
import JrnVers from './Components/jrn-versement';
import DonatorManager from './Components/donator-manager';
import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CompteManager from './Components/compte-manager';
import JrnDepenses from './Components/jrn-depense';
import JrnPetiteCaisse from './Components/jrn-pc';
import JrnDepartement from './Components/jrn-department';
import JrnComptes from './Components/jrn-comptes';
import Users from './AdmComponents/users';
import Eglises from './AdmComponents/eglises';
import MdpForm from './Components/reinit-mdp';
import VersementsManager from './AdmComponents/versement-cash';
import VersementsBanqueManager from './AdmComponents/versement-banque';
import CaisseCenter from './AdmComponents/caisse-center';
import CaisseRecette from './AdmComponents/caisse-recette';
import VerseForm from './Components/verse-form';
import DBManager from './AdmComponents/db-manager';
import EBPexport from './AdmComponents/EBP-export';
import AlerteManager from './AdmComponents/alerte-manager';

//dark mode et proposition de palette de couleur(en fonction du mode)

const agent = sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')) : {}

export const theme = createTheme({
    status: {
      danger: '#e53e3e',
      error: '#96031A'
    },
    typography:{
      subtitle1:{
        fontSize:16,
        fontWeight:'bold'
      },
      body1:{
        fontSize:15
      },
      info:{
        fontSize:13
      }
    },
    palette: {
      primary: {
        main: agent.role==='gestionnaire'? '#4682B4': '#255760', //rgb blue: 70, 130, 180
        darker: '#1B3E45',
        background:'rgba(37, 87, 96,0.5)'
      },
      warning: {
        main: '#D5A021',
      },
      action:{
        hover: 'rgba(37, 87, 96, 0.1)'
      },
      neutral: {
        main: '#fff',
        contrastText: '#000',
      },
      turquoise: {
        main: '#79E1D5',
        contrastText: '#FFF'
      },
      valide: {
        main: '#5da271',
        contrastText: '#FFF'
      },
      verdigris: {
        main: '#51B2A7',
        contrastText: '#FFF'
      },
      purple: {
        main: '#BF49A5',
        contrastText: '#FFF'
      },
      carmine: {
        main: '#96031A',
        contrastText: '#FFF',
        background: 'rgba(150, 3, 26, 0.5)'
      },
      grey: {
        main: '#BCC9C7',
        contrastText: "#000"
      },
      dark: {
        main: '#000',
        contrastText: "#FFF"
      }
    },
    components:{
      MuiTableCell:{styleOverrides:{
        head: {
          backgroundColor: "#50787F",
          color: '#fff'
        },
        root:{
          fontSize:14
        }
      }},
      MuiTableRow: {styleOverrides:{
        root:{
          '&:nth-of-type(even)':{
            backgroundColor:"rgba(37, 87, 96, 0.05)"
          }
        },
      }}
    }
});
export const Context = createContext()

const routes = [
  {path:"/recettes/enregistrement-des-fonds", element: <RegistFond/>},
  {path:"/versements/enregistrement", element: <VerseForm/>},
  {path:"/depenses/enregistrement", element: <RegistDepense/>},

  {path:"/cloture", element: <Cloture/>},
  {path:"/rapports", element: <Rapport/>},

  {path:"/journal/global", element: <GrandLivre/>},
  {path:"/journal/dons", element: <JrnDon/>},
  {path:"/journal/versements", element: <JrnVers/>},
  {path:"/journal/depenses", element: <JrnDepenses/>},
  {path:"/journal/petite-caisse", element: <JrnPetiteCaisse/>},
  {path:"/journal/départements", element: <JrnDepartement/>},
  {path:"/comptes/consultation", element: <JrnComptes/>},

  {path:"/comptes", element: <CompteManager/>},
  {path:"/donateurs", element: <DonatorManager/>},
  {path:"/users", element: <Users/>},
  {path:"/eglises", element: <Eglises/>},
  {path:"/dada-base", element: <DBManager/>},

  {path:"/export/ebp", element: <EBPexport/>},
  {path:"/alertes", element: <AlerteManager/>},

  {path:"/set-password/:token", element: <MdpForm/>},

  {path:"/caisse/versements", element: <VersementsManager/>},
  {path:"/caisse", element: <CaisseCenter/>},
  {path:"/caisse/recette", element: <CaisseRecette/>},

  {path:"/versements/banque", element: <VersementsBanqueManager/>}
]

const unlogged_router = createBrowserRouter([
    {path:"/", element: <Login/>},
    {path:"/set-password/:token", element: <MdpForm/>},
    {path:"*", element: <Login/>}
  ])

export default function App() {
  const user = JSON.parse(sessionStorage.getItem('user'))
  const [isConnect, setConnect] = useState(sessionStorage.getItem("token") ? true : false)
  const [eglise, seteglise] = useState(sessionStorage.getItem('eglise')?JSON.parse(sessionStorage.getItem('eglise')):'')

  function updateConnect(newValue) {
    setConnect(newValue)
  }

  function setEglise(value) {
    seteglise(value)
    sessionStorage.setItem('eglise', value==='indifferent' ? sessionStorage.getItem('original_eglise') : JSON.stringify(value))
  }

  return(
    <Context.Provider value={{ isConnect, updateConnect, eglise, setEglise }} >
      <ThemeProvider theme={theme}>
        <React.StrictMode>
          <RouterProvider router={isConnect ? createBrowserRouter([{path:"/", element: <Home/>}, ...routes.filter(route=> user?.access.includes(route.path)||(user?.access.includes('/caisse')&&/^\/caisse\/.+$/.test(route.path))), {path:"*", element: <Home/>}]): unlogged_router}/>
        </React.StrictMode>
      </ThemeProvider>
    </Context.Provider>
  );

}